import { render, staticRenderFns } from "./HappyPage.vue?vue&type=template&id=a79a3c6e&scoped=true"
import script from "./HappyPage.vue?vue&type=script&lang=js"
export * from "./HappyPage.vue?vue&type=script&lang=js"
import style0 from "./HappyPage.vue?vue&type=style&index=0&id=a79a3c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a3c6e",
  null
  
)

export default component.exports